<template>
	<div class="isStylePageContent">
		<h4 class="form-block-title">商品購買折扣</h4>
		<FormItemGroup v-if="renderList.length > 0 && submitData.length > 0" 
			:render-list="renderList" 
			:default-value="submitData"
			type="good"
			@updateSubmitData="updateSubmitData" 
			@continueChangeTab="continueChangeTab" 
			/>
	</div>
</template>
  
<script>
import memberLevelDiscountMixin from '@src/mixins/memberLevelDiscountMixin'
import lazyLoadComponent from '@router/lazyload-component'
export default {
	name: 'MemberLevelSettingStep2Goods',
	data() {
		return {
			renderList: [], // 純服務列表
			submitData: [], // 此次要渲染的資料(includeDBData)
		};
	},
	props: {
		// tempUserInputData: {
		// 	type: Object,
		// 	default: () => {}
		// }
	},
	watch: {},
	mixins: [memberLevelDiscountMixin],
	computed: {
	},
	inject: ['dbData', 'isEdit'],
	created() { },
	async mounted() {
		await this.fetchList()
		this.composeSubmitData()
	},
	methods: {
		async fetchList() {
			const { items } = await this.$store.dispatch('product/fetchNormalServiceData', {
				types: ['goods'],
				paginate: 0
			})
			this.renderList = items
		},
		/**
		 * @description 組成submitData
		 */
		composeSubmitData() {
			try {
				this.submitData = this.renderList.reduce((accu, cur) => {
					let rawObj = this.idFormat('good')
					rawObj = this.findDiscountInDb(cur.id, rawObj)
					accu.push(rawObj)
					return accu
				}, [])
			} catch (error) {
				console.error(error.message)
			}
		},
		/**
		 * @description 找到已存的discount修改值(for修改初始化) & 放到畫面上
		 * @param {*} id 
		 * @param {*} rawObj 
		 */
		findDiscountInDb(id, rawObj) {
			try {
				rawObj['id'] = id
				const index = this.dbData['services'] ? this.dbData['services'].findIndex(item => item.id === id) : -1
				if (index > -1) {
					rawObj['discount'] = parseInt(this.dbData['services'][index].discount)
					rawObj['discountType'] = this.dbData['services'][index].discountType
				}
				return rawObj
			} catch (error) {
				console.error(error.message)
			}
		},
	},
	components: {
		FormItemGroup: () => lazyLoadComponent(import('./FormItemGroup')),
	},
};
</script>
  
<style lang="scss" module></style>
  